// Token of the highest threshold reached, whatever the array order. A leaf
// module (no i18n): the Workload widget reads it outside the Gantt.
export const tierFor = (pct, tiers) => {
  if (pct == null || !Array.isArray(tiers)) return null;
  let best = null;
  tiers.forEach((tier) => {
    if (tier && pct >= tier.threshold && (!best || tier.threshold > best.threshold)) best = tier;
  });
  return best ? best.token : null;
};
